(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2928],{

/***/ 93239:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/item-list/[id]/[slug]",
      function () {
        return __webpack_require__(99388);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dd": function() { return /* binding */ onItemCustomization; },
/* harmony export */   "Tg": function() { return /* binding */ onItemUpdateBySignature; },
/* harmony export */   "d4": function() { return /* binding */ onItemUpdate; }
/* harmony export */ });
/* harmony import */ var _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63228);
/* harmony import */ var _utils_listeners__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25268);


const onItemUpdate = async (item, direction)=>{
    try {
        await _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_0__/* ["default"].updateCartItem */ .ZP.updateCartItem(item, {
            direction
        });
    } catch (err) {
        if (err.message === _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Exceptions.ITEM_CUSTOMIZATION_REQUIRED */ .XM.ITEM_CUSTOMIZATION_REQUIRED) {
            _utils_listeners__WEBPACK_IMPORTED_MODULE_1__/* .PubSub.getInstance */ .pS.getInstance().emit(_utils_listeners__WEBPACK_IMPORTED_MODULE_1__/* .EVENTS.ITEM_CUSTOMIZATION_REQUIRED */ .FP.ITEM_CUSTOMIZATION_REQUIRED, item);
        } else if (err.message === _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Exceptions.ITEM_REPEAT_OR_NOT_REQUIRED */ .XM.ITEM_REPEAT_OR_NOT_REQUIRED) {
            _utils_listeners__WEBPACK_IMPORTED_MODULE_1__/* .PubSub.getInstance */ .pS.getInstance().emit(_utils_listeners__WEBPACK_IMPORTED_MODULE_1__/* .EVENTS.ITEM_REPEAT_OR_NOT_REQUIRED */ .FP.ITEM_REPEAT_OR_NOT_REQUIRED, item);
        } else if (err.message === _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Exceptions.STORE_SELECTION_REQUIRED */ .XM.STORE_SELECTION_REQUIRED) {
            _utils_listeners__WEBPACK_IMPORTED_MODULE_1__/* .PubSub.getInstance */ .pS.getInstance().emit(_utils_listeners__WEBPACK_IMPORTED_MODULE_1__/* .EVENTS.STORE_SELECTION_REQUIRED */ .FP.STORE_SELECTION_REQUIRED);
        }
        throw err;
    }
};
const onItemUpdateBySignature = async (item, direction)=>{
    await _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_0__/* ["default"].updateCartItemBySignature */ .ZP.updateCartItemBySignature(item, direction);
};
const onItemCustomization = async (item)=>{
    _utils_listeners__WEBPACK_IMPORTED_MODULE_1__/* .PubSub.getInstance */ .pS.getInstance().emit(_utils_listeners__WEBPACK_IMPORTED_MODULE_1__/* .EVENTS.ITEM_CUSTOMIZATION_REQUIRED */ .FP.ITEM_CUSTOMIZATION_REQUIRED, item, true);
};


/***/ }),

/***/ 99388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _item_id_slug___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57927);

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (_item_id_slug___WEBPACK_IMPORTED_MODULE_0__["default"]);


/***/ }),

/***/ 57927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Molecules/ItemDetailCard.js
var ItemDetailCard = __webpack_require__(991);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Cells/RecommendationCarousel.js
var RecommendationCarousel = __webpack_require__(25342);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Molecules/ItemCard.js
var ItemCard = __webpack_require__(6501);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/main.js + 244 modules
var main = __webpack_require__(65460);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-sdk/dist/esm/index.js + 5 modules
var esm = __webpack_require__(63228);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 10 modules
var dist_esm = __webpack_require__(16033);
// EXTERNAL MODULE: ./pages/item/[id]/item.module.scss
var item_module = __webpack_require__(8915);
var item_module_default = /*#__PURE__*/__webpack_require__.n(item_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./hooks/cart.util.ts
var cart_util = __webpack_require__(12557);
// EXTERNAL MODULE: ./hooks/iframe.hook.ts
var iframe_hook = __webpack_require__(30082);
;// CONCATENATED MODULE: ./editor-static-data/item-details.json
var item_details_namespaceObject = JSON.parse('{"k":{"current_stock":-1,"display_price":null,"food_type":"2","has_options":true,"id":123,"image_blur_hash":null,"image_url":"https://i.ibb.co/D1kwjws/item-card-placeholder.jpg","item_desc":"Sample item, your description goes here","item_price":200,"item_title":"Sample item one","likes":5,"markup_price":0,"price_descriptor":"Per Bucket","service_tax_rate":null,"slug":"sample-item-1","sort_order":0,"vat_rate":null,"extras":[{"id":145,"name":"Nutritional info","key_values":[{"id":49999,"key":"protein_grams","value":"10"},{"id":50377,"key":"Carbs_grams","value":"45"},{"id":50378,"key":"random stuff","value":"100"},{"id":50379,"key":"No value check","value":""},{"id":50380,"key":"","value":""}]}]},"$":[{"category":{"id":12,"name":"Non-Veg","slug":"non-veg","sort_order":2},"item_title":"Burger with Fries","current_stock":-1,"food_type":"2","has_options":true,"id":1234,"image_url":"https://cdn.urbanpiper.com/media/bizmedia/2022/12/27/Frame_54149_1672148986.png","image_blur_hash":null,"item_desc":"Chicken packed with spices to make you happy illing and covered with a savory sauce. Originally from Mexican cuisine, enchiladas can be filled with various ingredients, including meats, cheese, beans, potatoes, vegetables, or combinations The flavor of fattoush is bright, assertive herbal.An enchilada is a corn tortilla rolled around a filling and covered with a savory sauce. Originally from Mexican cuisine, enchiladas can be filled with various ingredients, including meats, cheese, beans, potatoes, vegetables, or combinations","item_price":300,"price_descriptor":"Serves 1","recommended":null,"slug":"burger-with-fries","sort_order":5,"unit_weight":null,"likes":4},{"category":{"id":312,"name":"Desserts","slug":"low-calorie-no-sugar-guilt-free-desserts-for-everyone-looking-for-healthy-options","sort_order":5},"item_title":"Chicken Steak","current_stock":-1,"food_type":"1","has_options":true,"id":12345,"image_url":"https://cdn.urbanpiper.com/media/bizmedia/2022/12/27/Frame_54147_1672148220.png","image_blur_hash":null,"item_desc":"A churro is a type of fried dough from Spanish and Portuguese cuisine.","item_price":90,"price_descriptor":"Serves 4","recommended":null,"slug":"chicken-steak","sort_order":3,"unit_weight":null,"likes":6},{"category":{"id":12334,"name":"Desserts","slug":"low-calorie-no-sugar-guilt-free-desserts-for-everyone-looking-for-healthy-options","sort_order":5},"item_title":"Mango Pudding","current_stock":-1,"food_type":"1","has_options":true,"id":12352,"image_url":"https://cdn.urbanpiper.com/media/bizmedia/2022/04/06/Chinese-mango-pudding.jpg","image_blur_hash":null,"item_desc":"contains the goodness of alphonso mango","item_price":130,"price_descriptor":null,"recommended":null,"slug":"mango-pudding","sort_order":6,"unit_weight":null,"likes":1},{"category":{"id":1235,"name":"Non-Veg","slug":"non-veg","sort_order":2},"item_title":"Chicken Chilli","current_stock":-1,"food_type":"2","has_options":true,"id":3241,"image_url":"https://cdn.urbanpiper.com/media/bizmedia/2023/02/27/Final_uploaded_logo_1677483418.jfif","image_blur_hash":null,"item_desc":"A feast, just for you! <br> Mutton bone-in pieces known for its taste, texture, juiciness & softness, sourced from shoulder, ribs, loin & legs of farmed raised goat.","item_price":485,"price_descriptor":null,"recommended":null,"slug":"chicken-chilli","sort_order":12,"unit_weight":null,"likes":0}]}');
// EXTERNAL MODULE: ./components/seo_data/index.tsx
var seo_data = __webpack_require__(45534);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./hooks/is_mobile.hook.ts
var is_mobile_hook = __webpack_require__(43346);
;// CONCATENATED MODULE: ./pages/item/[id]/[slug].tsx

















function ItemDetail(param) {
    let { _itemInfo , pageConfig , seoData , openGraphData  } = param;
    const isMobile = (0,is_mobile_hook/* useIsMobile */.d)();
    const [itemInfo, setItemInfo] = (0,react.useState)({});
    const router = (0,next_router.useRouter)();
    const { t  } = (0,dist_esm/* useTranslation */.$G)();
    const useCartState = esm/* default.getCartState */.ZP.getCartState().hook();
    const [favouritesList, setFavouritesList] = (0,react.useState)([]);
    const [cartItems, cartItemQty] = useCartState((state)=>{
        var _state_cart, _state_cart1;
        return [
            ((_state_cart = state.cart) === null || _state_cart === void 0 ? void 0 : _state_cart.items) || [],
            (_state_cart1 = state.cart) === null || _state_cart1 === void 0 ? void 0 : _state_cart1.item_count
        ];
    });
    const { loadedInIframe  } = (0,iframe_hook/* default */.Z)();
    (0,react.useEffect)(()=>{
        (async ()=>{
            try {
                var _router_query;
                const newItemInfo = await esm/* default.getItemById */.ZP.getItemById({
                    item_id: Number((_itemInfo === null || _itemInfo === void 0 ? void 0 : _itemInfo.id) || (router === null || router === void 0 ? void 0 : (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.id))
                });
                setItemInfo(newItemInfo);
            } catch (error) {
                console.log(error, "itemInfoError");
            }
        })();
    }, []);
    const cartItemQuantityMap = (0,react.useMemo)(()=>cartItems.reduce((acc, item)=>{
            if (!acc[item.id]) {
                acc[item.id] = 0;
            }
            acc[item.id] += item.quantity;
            return acc;
        }, {}), [
        cartItems,
        cartItemQty
    ]);
    const { recommendedItems: showRecommendedItems  } = pageConfig.customizations;
    const [recommendedItems, setRecommendedItems] = react.useState([]);
    (0,react.useEffect)(()=>{
        if (!(itemInfo === null || itemInfo === void 0 ? void 0 : itemInfo.id)) {
            if (loadedInIframe) {
                setItemInfo(item_details_namespaceObject.k);
                if (showRecommendedItems) {
                    setRecommendedItems(item_details_namespaceObject.$);
                } else {
                    setRecommendedItems([]);
                }
            }
        } else {
            if (showRecommendedItems) {
                esm/* default.getRecommendedItems */.ZP.getRecommendedItems(itemInfo === null || itemInfo === void 0 ? void 0 : itemInfo.id).then((res)=>{
                    setRecommendedItems(res);
                });
            }
        }
        fetchFavourites();
        return ()=>{
            if (showRecommendedItems) {
                setRecommendedItems([]);
            }
        };
    }, [
        itemInfo,
        showRecommendedItems,
        loadedInIframe
    ]);
    const fetchFavourites = ()=>{
        return esm/* default.getFavorites */.ZP.getFavorites().then((res)=>{
            if ((res === null || res === void 0 ? void 0 : res.status) !== "error") {
                setFavouritesList(res === null || res === void 0 ? void 0 : res.map((item)=>item.item.id));
            }
        }).catch((err)=>{
            console.log(err, "err");
        });
    };
    const toggleFavourite = async (item, status)=>{
        if (status) {
            await esm/* default.addItemAsFavourite */.ZP.addItemAsFavourite(item.id);
        } else {
            await esm/* default.removeItemAsFavourite */.ZP.removeItemAsFavourite(item.id);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (item_module_default()).item,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo_data/* default */.Z, {
                seoData: seoData,
                openGraphData: openGraphData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDetailCard/* default */.Z, {
                        item: itemInfo,
                        count: cartItemQuantityMap[itemInfo === null || itemInfo === void 0 ? void 0 : itemInfo.id] || 0,
                        onClickShare: ()=>{},
                        onItemUpdate: cart_util/* onItemUpdate */.d4,
                        isFavourite: favouritesList === null || favouritesList === void 0 ? void 0 : favouritesList.includes(itemInfo === null || itemInfo === void 0 ? void 0 : itemInfo.id),
                        toggleFavourite: (status)=>{
                            toggleFavourite(itemInfo, status);
                        },
                        imageComponent: (image_default())
                    }),
                    (recommendedItems === null || recommendedItems === void 0 ? void 0 : recommendedItems.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendationCarousel/* default */.Z, {
                        itemlistLength: recommendedItems === null || recommendedItems === void 0 ? void 0 : recommendedItems.length,
                        children: recommendedItems.map((item)=>{
                            return /*#__PURE__*/ (0,react.createElement)(ItemCard/* default */.Z, {
                                ...item,
                                count: cartItemQuantityMap[item.id] || 0,
                                key: item.id,
                                onItemUpdate: cart_util/* onItemUpdate */.d4,
                                onClickCallback: ()=>{
                                    router.push("/item/".concat(item.id, "/").concat(item.slug));
                                },
                                isFavourite: favouritesList === null || favouritesList === void 0 ? void 0 : favouritesList.includes(item === null || item === void 0 ? void 0 : item.id),
                                isFavouriteEnabled: true,
                                toggleFavourite: (status)=>{
                                    toggleFavourite(item, status);
                                }
                            });
                        })
                    }),
                    isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* FloatingStack */.Jf, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (item_module_default()).item_detail__customize_button,
                            children: (itemInfo === null || itemInfo === void 0 ? void 0 : itemInfo.has_options) && !cartItemQuantityMap[itemInfo === null || itemInfo === void 0 ? void 0 : itemInfo.id] ? /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* Button */.zx, {
                                size: "lg",
                                variant: "solid",
                                onClick: async ()=>await (0,cart_util/* onItemUpdate */.d4)({
                                        ...itemInfo,
                                        quantity: 0
                                    }, 1),
                                children: t("itemCard.customize")
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* AddToCart */.o4, {
                                classes: "item-detail-card__add-to-cart",
                                quantity: cartItemQuantityMap[itemInfo === null || itemInfo === void 0 ? void 0 : itemInfo.id] || 0,
                                loading: false,
                                stock: itemInfo === null || itemInfo === void 0 ? void 0 : itemInfo.current_stock,
                                variant: "solid",
                                onItemUpdate: async (id, quantity, dir)=>{
                                    cart_util/* onItemUpdate */.d4 && await (0,cart_util/* onItemUpdate */.d4)({
                                        quantity,
                                        id,
                                        ...itemInfo
                                    }, dir);
                                },
                                itemId: itemInfo === null || itemInfo === void 0 ? void 0 : itemInfo.id
                            })
                        })
                    })
                ]
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var _slug_ = (ItemDetail);


/***/ }),

/***/ 25268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FP": function() { return /* binding */ EVENTS; },
/* harmony export */   "pS": function() { return /* binding */ PubSub; }
/* harmony export */ });
/**
 * this file creates a pub/sub system for the app
 */ class PubSub {
    static getInstance() {
        if (!PubSub.instance) {
            PubSub.instance = new PubSub();
        }
        return PubSub.instance;
    }
    addListener(event, callback) {
        if (!this.events[event]) {
            this.events[event] = [];
        }
        this.events[event].push(callback);
        return {
            event,
            index: this.events[event].length - 1
        };
    }
    removeListener(listener) {
        var _this_events, _this_events_listener_event;
        if (!((_this_events = this.events) === null || _this_events === void 0 ? void 0 : (_this_events_listener_event = _this_events[listener.event]) === null || _this_events_listener_event === void 0 ? void 0 : _this_events_listener_event[listener.index])) {
            return;
        }
        this.events[listener.event] = this.events[listener.event].filter((cb, index)=>index !== listener.index);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        if (!this.events[event]) {
            return;
        }
        this.events[event].forEach((cb)=>cb(...args));
    }
    constructor(){
        this.events = {};
    }
}
/* harmony default export */ __webpack_exports__["ZP"] = (PubSub.getInstance());
var EVENTS;
(function(EVENTS) {
    EVENTS[EVENTS["LOGIN_REQUIRED"] = 0] = "LOGIN_REQUIRED";
    EVENTS[EVENTS["STORE_SELECTION_REQUIRED"] = 1] = "STORE_SELECTION_REQUIRED";
    EVENTS[EVENTS["ITEM_CUSTOMIZATION_REQUIRED"] = 2] = "ITEM_CUSTOMIZATION_REQUIRED";
    EVENTS[EVENTS["ITEM_REPEAT_OR_NOT_REQUIRED"] = 3] = "ITEM_REPEAT_OR_NOT_REQUIRED";
    EVENTS[EVENTS["ADD_TO_CART"] = 4] = "ADD_TO_CART";
})(EVENTS || (EVENTS = {}));


/***/ }),

/***/ 8915:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"item_item__jU0MJ","item_detail__customize_button":"item_item_detail__customize_button__VQiA6"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2778,3791,5390,9355,1620,5675,8862,223,5306,2508,9281,145,2806,1112,2149,8809,5570,5460,9774,2888,179], function() { return __webpack_exec__(93239); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);